import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InboxOutlined from '@mui/icons-material/InboxOutlined';
import Typography from '@mui/material/Typography';

/**
 * Vazio de VERDADE: a API respondeu 200 e a lista veio sem itens.
 *
 * Este componente NUNCA é usado para falha. A doc proíbe nominalmente
 * apresentar indisponibilidade como "sem pendências" — para isso existe
 * `EstadoDeErro`, e há um teste que exige que o texto daqui não apareça
 * quando a API devolve 500.
 */
export function EstadoVazio({
  titulo,
  descricao,
  acao,
}: {
  titulo: string;
  descricao: string;
  acao?: { rotulo: string; aoClicar: () => void };
}): React.JSX.Element {
  return (
    <Box sx={{ textAlign: 'center', px: 3, py: 6 }}>
      <InboxOutlined sx={(tema) => ({ fontSize: 40, color: tema.palette.text.disabled })} />
      <Typography variant="h3" sx={{ mt: 1 }}>
        {titulo}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {descricao}
      </Typography>
      {acao ? (
        <Button variant="outlined" onClick={acao.aoClicar} sx={{ mt: 2 }}>
          {acao.rotulo}
        </Button>
      ) : null}
    </Box>
  );
}
